export const GET_ALL_DEPARTMENTS = 'GET_ALL_DEPARTMENTS';
export const GET_A_DEPARTMENT = 'GET_A_DEPARTMENT';
export const CREATE_DEPARTMENT = 'CREATE_DEPARTMENT';
export const UPDATE_DEPARTMENT = 'UPDATE_DEPARTMENT';
export const DELETE_DEPARTMENT = 'DELETE_DEPARTMENT';